<div class="head">
  <div class="eyes">
    <i class="eye1"></i>
    <i class="eye2"></i>
  </div>
  <div class="mouth"></div>
</div>
